import { render, staticRenderFns } from "./InvoiceBlockCard.vue?vue&type=template&id=124c6009"
import script from "./InvoiceBlockCard.vue?vue&type=script&lang=ts"
export * from "./InvoiceBlockCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports